import DataTable from "react-data-table-component";
import { GoChevronDown } from "react-icons/go";

import { useConfig } from "../../../context/config-context";

const InterventionTable = ({ interventions = [] }) => {
  const siteConfig = useConfig();
  const tabConfig = siteConfig.components.patient_tabs.find(
    (t) => t.id === "interventions"
  );

  return (
    <DataTable
      columns={tabConfig.table.columns()}
      data={interventions}
      customStyles={tabConfig.table.customStyles}
      defaultSortFieldId={1}
      defaultSortAsc={false}
      sortIcon={<GoChevronDown color="var(--light)" />}
      striped
      highlightOnHover
      dense
      theme="solarized"
      noDataComponent={
        <span className="my-5 text-neutral-dark">{tabConfig.table.none}</span>
      }
      paginationComponentOptions={{
        rowsPerPageText: tabConfig.table.pagination.rowsPerPageText,
        rangeSeparatorText: tabConfig.table.pagination.rangeSeparatorText,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: "All",
      }}
    />
  );
};

export default InterventionTable;
